var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 55",
    style: {
      enableBackground: "new 0 0 56 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,39.7c1.8,0,3.2,1.4,3.2,3.2c0,1.3-0.8,2.4-2,2.9c-1.2,0.5-2.5,0.2-3.5-0.7c-0.9-0.9-1.2-2.3-0.7-3.5 S25.9,39.7,27.2,39.7z M40.4,39.7c1.8,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2c-1.7,0-3.2-1.4-3.2-3.2 C37.2,41.1,38.7,39.7,40.4,39.7z M27.2,41.2c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7 C28.9,42,28.1,41.2,27.2,41.2z M40.4,41.2c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7s1.7-0.7,1.7-1.7 C42.1,42,41.3,41.2,40.4,41.2z M16.5,10.3c0.4,0,0.7,0.3,0.7,0.6l0.6,3.1h28c1.6,0,3,1.6,3,3.5c0,0,0,0.1,0,0.1L46,33.4 c-0.1,0.4-0.4,0.6-0.7,0.6H21.7l0.6,3.2h24.1c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7H21.8c-0.4,0-0.7-0.3-0.7-0.6l-5.1-26.3 h-8c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H16.5z M45.8,15.5H18.1l3.3,17h23.2l2.7-15.1C47.3,16.3,46.6,15.5,45.8,15.5 L45.8,15.5z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.70f0722f890f31372c35b19d7054b047.svg";
export { ForwardRef as ReactComponent };